import { createStore } from 'satcheljs';
import type { ItemPeekStore } from './schema/ItemPeekState';

let peekStoreData: ItemPeekStore = {
    viewState: undefined,
};

export default createStore<ItemPeekStore>('peekStoreData', peekStoreData);
